import {TenantLine} from "../IDMS/Interfaces/IUsers";

export const AuthLevels = ["blocked", "neutral", "reader", "editor", "admin"]
export const defaultAuth: string = "neutral"
export const defaultTenantSystem: TenantLine[] = [{
    id: 0,
    scopes: ["user"],
    value: defaultAuth,
    tmp: "",
    fullscope: "user"
}]
